export default "__VITE_ASSET__Dpclhbtt__"